import React from "react";

import { Typography } from "clearsense-ui/components";

export const SEARCH_CODE = { label: "Code", value: "code" };
export const SEARCH_DESCRIPTION = {
  label: "Description",
  value: "description",
};
export const EXPORT_PDF = "pdf";
export const EXPORT_CSV = "csv";
export const SELECTED_OPTION = {
  code: { ...SEARCH_CODE },
  description: { ...SEARCH_DESCRIPTION },
};

export const COLUMN_DATA = [
  {
    dataIndex: "code",
    key: "code",
    title: "CODE",
    ellipsis: {
      showTitle: true,
    },
    render: text => (
      <Typography
        className="text-indigo-600 dark:text-indigo-400"
        type="uppercase"
      >
        {text}
      </Typography>
    ),
  },
  {
    dataIndex: "description",
    key: "description",
    ellipsis: {
      showTitle: true,
    },
    title: "Description",
    render: text => <Typography type="uppercase">{text}</Typography>,
  },
];

export const COLORS = [
  "#193058",
  "#ffc009",
  "#ff8d3e",
  "#f4635e",
  "#cc4975",
  "#92407e",
  "#543b73",
];
